"use client";

import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

interface ProfessionalAboutProps {
    about?: string;
    name?: string;
    hasEducation?: boolean;
    className?: string;
}

export function ProfessionalAbout({
    about,
    name,
    hasEducation = false,
    className = ""
}: ProfessionalAboutProps) {
    const [isAboutExpanded, setIsAboutExpanded] = useState(false);

    if (!about) return null;

    const firstName = name ? name.trim().split(' ')[0] : 'Professional';
    const isLongText = (about?.length ?? 0) > 200;

    return (
        <div
            className={`${hasEducation ? 'lg:col-span-7' : 'lg:col-span-12'} bg-white rounded-2xl p-6 sm:p-7 border border-blue-100/80 shadow-sm flex flex-col justify-between ${className}`}
        >
            <div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                    About {firstName}
                </h3>
                <p className={`text-sm text-gray-600 leading-relaxed whitespace-pre-line transition-all ${!isAboutExpanded ? 'line-clamp-4' : ''}`}>
                    {about}
                </p>
            </div>

            {isLongText && (
                <div className="mt-4 pt-2">
                    <button
                        onClick={() => setIsAboutExpanded(!isAboutExpanded)}
                        className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 transition-colors cursor-pointer"
                    >
                        <span>{isAboutExpanded ? 'Show Less' : 'Read More'}</span>
                        <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                </div>
            )}
        </div>
    );
}

export default ProfessionalAbout;
